export enum VacationTypeCreation{
  vacation_created = <any>"VACATION_CREATED",
  vacation_extention = <any>"VACATION_EXTENSION",
};


// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/modals/vacation-type-creation.ts